import { Dispatch, useEffect} from "react";
import { useConfigService } from './useConfigService';
import { useContentService } from './useContentService';
import { IADPActions } from "../state/Actions";
import { IADPState} from "../types";
import { actions } from "../state";
import { useIPCBridge } from "./useIPCBridge";
const logPrefix = "[ADPClient][InitilizeServiceHook]"
console.log(logPrefix, "initializing ADP app...");
export function useInitilizeService( dispatch: Dispatch<IADPActions>,appState: IADPState) {
   const config = useConfigService(dispatch);
   const {fetchContent}= useContentService(dispatch);
   const {sendGreeting} = useIPCBridge(dispatch,appState);
     useEffect(() => {
      if (!config) {
        return;
      }
     dispatch(actions.createSetConfigAction(config));
     fetchContent(appState.sessionState.selectedLanguage === "english" ? "en" : "es",true).then((result)=>{
      if(result){
        console.log(logPrefix, "ADP app is initilized...");
        sendGreeting();
      }
     });
     
    }, [config]);
    return config;
}
